import { render } from "./Tree.vue?vue&type=template&id=e2fcc3a0&scoped=true"
import script from "./Tree.vue?vue&type=script&lang=js"
export * from "./Tree.vue?vue&type=script&lang=js"

import "./Tree.vue?vue&type=style&index=0&id=e2fcc3a0&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2fcc3a0"]])

export default __exports__